import { getRunTime } from '../../../../public-resource/libs/utils/index'
import { axios as $http } from 'cm'

function renderAsideToolsButton(domText = '匿名提问') {
  const link =
    getRunTime('//m.xinli001.com') + '/qa/postQuestionView?node=1&isNiming=true'
  const html = `
    <a href="${link}">
      <div class="aside-tools">${domText}</div>
    </a>
  `
  document.body.insertAdjacentHTML('beforeend', html)
}

function fetchJsonCantonalList() {
  const { search } = window.location
  $http
    .get(
      'https://yiapp.xinli001.com/commonConfigure/getConfigureByCode?configureCode=cantonal_teacher_mask'
    )
    .then(res => {
      const searchList = search.slice(1).split('&')
      const index = searchList.findIndex(i => i.includes('cantonal_id'))
      const cantonalId = searchList[index].split('=')[1] || 0
      const jsonCantonalIdList = Object.keys(
        JSON.parse(res.data.data.content).cantonalId
      )
      const text = jsonCantonalIdList.includes(cantonalId) ? '提问' : '匿名提问'
      $('.aside-tools').text(text)
    })
}

renderAsideToolsButton()
fetchJsonCantonalList()



// WEBPACK FOOTER //
// ./src/pages/ask/askBranch/render/asideToolsButton.js